module.exports = __webpack_public_path__ + "img/clement-tv2-min.3831390a.png";